import gql from 'graphql-tag';

const RECENTLY_OPENED_CONTRACTS_QUERY = gql`
  query {  
    recentlyOpenedContracts{
      contractId
      contractNumber 
      annualPremiumAllIn    
      customer {            
        firstName
        lastName  
      }    
      enterprise {            
        name
      }    
      insuranceBroker {      
        name
        producerNumber
      }
    }
  }
`;

export default RECENTLY_OPENED_CONTRACTS_QUERY;
